var map = {
	"./1/beskraen-recnik.gif": 27,
	"./1/creative-copywriter.gif": 28,
	"./1/magicna-kreativnost.gif": 29,
	"./1/prisposoblivost.gif": 30,
	"./10/empatija.gif": 31,
	"./10/psihologija.gif": 32,
	"./10/resava-problemi.gif": 33,
	"./10/uxui-designer.gif": 34,
	"./2/data-analyst.gif": 35,
	"./2/koristi-podatoci.gif": 36,
	"./2/roden-analiticar.gif": 37,
	"./2/strateg.gif": 38,
	"./3/3d-vizualizacija.gif": 39,
	"./3/AB-testiranje.gif": 40,
	"./3/Avtomatizacija.gif": 41,
	"./3/robotics-engineer.gif": 42,
	"./4/cyber-security.gif": 43,
	"./4/dark-web.gif": 44,
	"./4/forenzicar.gif": 45,
	"./4/hakiranje.gif": 46,
	"./5/agilna-metodologija.gif": 47,
	"./5/logika-i-analitika.gif": 48,
	"./5/software-tester.gif": 49,
	"./5/tehniki-na-testiranje.gif": 50,
	"./6/kompjuterska-vizualizacija.gif": 51,
	"./6/ml-engineer.gif": 52,
	"./6/pametni-algoritmi.gif": 53,
	"./6/vestacka-intelegencija.gif": 54,
	"./7/business-analyst.gif": 55,
	"./7/koristi-formuli.gif": 56,
	"./7/magionicar-za-excel.gif": 57,
	"./7/vizualizacija-na-podatoci.gif": 58,
	"./8/interaktiven-dizajn.gif": 59,
	"./8/kreativno-razmisluvanje.gif": 60,
	"./8/ljubopitnost.gif": 61,
	"./8/visual-animator.gif": 62,
	"./9/adobe-master.gif": 63,
	"./9/crypto-designer.gif": 64,
	"./9/ilustrativen-virtuoz.gif": 65,
	"./9/trendseter.gif": 66
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94;